import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { CommonServices } from '../../../../../../Services/common.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';

declare const Swal;
@Component({
    selector: 'g10-single-request-view',
    templateUrl: './single-request-view.component.html',
    styleUrls: ['./single-request-view.component.css']
})
export class SingleRequestViewComponent implements OnInit {

    public titleName: string;

    public requestID: string;
    public singleReqListLink = '/organization/transport-manager/request/list-request/';
    public paramReqType: any = '';
    public typeOfRequest: any = '';

    public viewRequestData: any = [];
    public requestResData = [];
    public requestFormFields: any = [];

    public totalResCount = 0;
    public processResCount = 0;

    public tableCols = [];
    public tableData = [];
    public tableSearchKeys = [];
    public filterTable: boolean = true;
    public enableTable: boolean = false;
    public activeTable = 'pendingAction';
    public noDataFoundEnable: boolean = false;
    public pendingActionCount = 0;
    public actionTakenCount = 0;

    public searchedValue: string = '';
    public searchInput: any = new Subject<string>();

    public closeActionTaken = true;
    public actionTakenPopup = true;
    public reqModalTitle = 'Take Action';
    public editTakeAction: boolean = true;
    public editTakeActionId = "";
    public editTakeActionData = {};
    public FormPreviewData = [];
    public currentPreviewResponseData: any = {};
    public closeFormPreview = true;
    public formPreviewPopup: boolean = true;
    public formPreviewModalName;
    public requestFormTitle;
    public requestFormNote;
    public requestFormPreviewFields: any = [];
    public showFormValue: boolean = true;
    public checked: boolean = false;
    public hide: boolean = false;
    public checkedDatas: any = [];
    // Date variables
    public startDate: any = new Date();
    public endDate: any = new Date();

    // validation area
    public shiftChangeForm: FormGroup;
    public errorObject: any = {
        startDate: '',
        endDate: '',
    }
    public formSubmitted: boolean = false;

    public transMode: any = '';
    public allSelObj: any = [];
    public columnObj: any = {
        empName: true,
        createdAt: true,
        branch: true,
        nodal: true,
        // Date: true,
        // CurrentRoute: true,
        NewRoute: true,
        // Message: true,
    }
    public fieldOptions = {
        reqStatus: [
            { name: 'Completed', value: 3 },
            //   {name:'In-Progress',value:2},
            // {name:'Pending',value:1},
            { name: 'Rejected', value: 4 },],
    };

    public checkingInput: boolean = true;

    public showDownloadBtn: boolean = false;
    public reqExlData: any = [];
    public excelData: any = [];
    public excelData2: any = [];
    public branchInformation: any = {};
    public matFormSize = '12px';
    public status: any;
    public approveBtn: boolean = false;
    public currentDate: boolean = true;
    public filterObj: any = {};

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private api: ApiService,
        private storage: StorageService,
        public swal: SweetAlert,
        public com: CommonServices,
        public excel: ExcelExportService,
        private fb: FormBuilder,
        private dateAdapter: DateAdapter<Date>
    ) {
        this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
        this.route.paramMap.subscribe((params: any) => {
            this.requestID = params.params.ID;
            this.paramReqType = params.params.requestType;
            this.typeOfRequest = params.params.requestType == 'custom-request' ? 'customId' : 'id';
            this.singleReqListLink = this.singleReqListLink + params.params.requestType;
            this.titleName = this.paramReqType.split('-').join(' ');
            this.formPreviewModalName = this.titleName + ' Form Preview';
        });
    }
    ngOnInit() {
        this.loadBranchList();
        this.getListRequest();
        this.filterFormLoad()
        this.getRequestResponses({
            startDate: new Date(new Date(this.shiftChangeForm.value.startDate).setHours(0)).getTime(),
            endDate: new Date(new Date(this.shiftChangeForm.value.endDate).setHours(23, 59, 59)).getTime(),
        });
    }

    // Select all row
    selectAll(e: any, i: any) {
        this.tableData.map((Obj, index) => {
            this.getcheckedObj(index, e)
        })
        this.checked = this.checkAllSelected
        if (this.checkedDatas.length > 0) {
            this.approveBtn = true
        } else {
            this.approveBtn = false
        }
    }
    get checkAllSelected() {
        return this.tableData.length == this.checkedDatas.length;
    }

    getcheckedObj(i: any, e: any) {
        if (e.target['checked'] == true) {
            let findIndex = this.checkedDatas.findIndex((item: any) => item.appRequestID == this.tableData[i]['appRequestID']);
            if (findIndex == -1) {
                this.checkedDatas.push({
                    appRequestID: this.tableData[i]['appRequestID'],
                    user: this.tableData[i]['user'],
                })
            }
        } else {
            this.checkedDatas = this.checkedDatas.filter(
                (data: any) => data.appRequestID != this.tableData[i]['appRequestID']
            )
        }
        this.tableData[i]['isChecked'] = e.target.checked;
        let fIndex = this.requestResData.findIndex((item: any) => item.appRequestID == this.tableData[i]['appRequestID'])
        if (fIndex > -1) {
            this.requestResData[fIndex]['isChecked'] = e.target.checked;
        }

        this.checked = this.checkAllSelected
        if (this.checkedDatas.length > 0) {
            this.approveBtn = true
        } else {
            this.approveBtn = false
        }
    }

    excelDownload() {
        let obj: any = {
            requestID: this.requestID,
        }
        if (Object.keys(this.shiftChangeForm.value).length > 0) {

            if (this.shiftChangeForm.value.reqStatus != '') {
                obj['reqStatus'] = this.status;
            }
            if (this.shiftChangeForm.value.search != '') {
                obj['search'] = this.shiftChangeForm.value.search.trim();
            }

            if (this.shiftChangeForm.value.transitMode != '') {
                obj['transitMode'] = this.transMode;
            }
        }
        // if(Object.keys(this.shiftChangeForm.value).length>0) obj = { ...obj,...this.shiftChangeForm.value};
        // reqStatus:this.status ? this.status:'',
        obj = {
            ...obj,
            startDate: new Date(this.shiftChangeForm.value.startDate).getTime(),
            endDate: new Date(this.shiftChangeForm.value.endDate).getTime(),
        }
        this.api.RequestResExcel(obj).then((res: any) => {
            if (res.status == 'success') {
                if (res.data && res.data.length > 0) {
                    this.reqExlData = res.data
                    this.exportToExcel()
                    if(['route_request','adhoc_request'].includes(this.viewRequestData['requestType'])){
                        this.rosterExcel();
                    }
                }
            }
        })
    }

    // Load form
    filterFormLoad() {
        this.shiftChangeForm = this.fb.group({
            search: new FormControl('', [Validators.pattern('^[^\s]+[-a-zA-Z\s]+([-a-zA-Z]+)*$')]),
            startDate: new FormControl(new Date(), [Validators.required]),
            endDate: new FormControl(new Date(), [Validators.required]),
            reqStatus: new FormControl(''),
            transitMode: new FormControl(''),
        });
    }
    public checkError = (controlName: string, errorName: string) => {
        return this.shiftChangeForm.controls[controlName].hasError(errorName);
    }

    getFilterValue(e: any, type: any) {
        if (type == 'tsMode') {
            this.transMode = e.value
        }
        if (type == 'status') {
            this.status = +e.value
        }
    }

    onSubmit() {
        this.formSubmitted = true;
        let checkObj = {
            startDate: new Date(this.shiftChangeForm.value.startDate).getTime(),
            endDate: new Date(this.shiftChangeForm.value.endDate).getTime(),
        }
        let isValid = this.validation(checkObj);
        if (isValid) {
            let obj = {
                startDate: new Date(new Date(this.shiftChangeForm.value.startDate).setHours(0)).getTime(),
                endDate: new Date(new Date(this.shiftChangeForm.value.endDate).setHours(23, 59, 59)).getTime(),
            }
            if (this.shiftChangeForm.value.search != '') {
                obj['search'] = this.shiftChangeForm.value.search.trim();
            }
            if (this.transMode != '') obj['transitMode'] = this.transMode;
            if (this.status != '' && this.activeTable == 'actionTaken') obj['reqStatus'] = this.status;
            this.getRequestResponses(obj);
            if (this.startDate == this.shiftChangeForm.value.startDate
                && this.endDate == this.shiftChangeForm.value.endDate) {
                this.currentDate = true
            }
        }
    }

    validation(data) {
        let objectKeys = Object.keys(this.errorObject);
        let isValid = true;
        for (let i = 0; i < objectKeys.length; i++) {
            let key = objectKeys[i];
            this.errorObject[key] = '';
            if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
                this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
                isValid = false;
            } else if ((key == 'startDate' || key == 'endDate')) {
                if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
                    isValid = false;
                    this.errorObject['endDate'] = 'Invalid end date';
                    this.formSubmitted = false
                    this.tableData = [];
                    this.noDataFoundEnable = true
                }
            }
        }
        return isValid;
    }

    checkValidation() {
        let obj = {
            startDate: new Date(this.shiftChangeForm.value.startDate).getTime(),
            endDate: new Date(this.shiftChangeForm.value.endDate).getTime(),
        }
        if (this.formSubmitted) this.validation(obj);
    }

    resetingTableValues() {
        this.requestResData.filter((resData: any) => resData['isChecked'] = false)
        this.approveBtn = false
    }

    aprovalObjs() {
        if (this.checkedDatas.length > 0) {
            this.openTakeAction(this.checkedDatas);
        }
    }

    actionTypeChanges(e: any) {
        this.changeTableView(e.target['value'])
    }

    upDateStatus(data) {
        if (data.status == '0') { data.status = 1; } else if (data.status == '1') { data.status = 0; }
        const obj = {
            orgID: this.storage.get('userInfo').orgID,
            requestID: data.requestID,
            status: data.status
        };
        this.api.UpdateRequest(obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status, res.status, res.message, 2000);
                this.router.navigate(['/organization/transport-manager/request/view-request']);
                this.getListRequest();
            }
            if (res.status == 'failure') {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getListRequest() {
        let reqType = this.paramReqType.split('-').join('_');
        const obj = {
            requestID: this.requestID,
        };
        this.api.ListRequest(obj).then((res: any) => {
            this.viewRequestData = res.data[reqType][0];
            // console.log(this.viewRequestData);

        }).catch((err) => {
            console.log(err);
        });
    }

    loadBranchList() {
        const orgID = this.storage.get('userInfo')?.orgID;
        if (!orgID) return;

        this.api.transportManagerBranchList({ orgID }).then((res: any) => {
            if (res?.status === 'success' && Array.isArray(res.data)) {
                this.branchInformation = {};
                for (let i = 0; i < res.data.length; i++) {
                    const branch = res.data[i];
                    if (branch?.branchID) {
                        this.branchInformation[branch.branchID] = branch.branchName || branch.branchID;
                    }
                }

                if (this.requestResData && this.requestResData.length > 0) {
                    this.changeTableView(this.activeTable);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getRequestResponses(filterObj: any = {}) {
        let obj = {
            requestID: this.requestID,
        };
        if (Object.keys(filterObj).length > 0) obj = { ...obj, ...filterObj };
        this.filterObj = filterObj;

        this.api.RequestResList(obj).then((res: any) => {
            this.requestResData = res.data;
            this.requestResData.map((allObj: any) => {
                allObj['isChecked'] = this.hide;
            })
            this.setActionCount(res.data);
            this.processFormPreview(this.viewRequestData.formFields);
            setTimeout(() => { this.setTableCols(this.viewRequestData.formFields); }, 100);
        }).catch((err) => {
            console.log(err);
        });
        if (this.requestResData.length > 0) this.currentDate = false
    }

    setActionCount(data) {
        if (data && data.length > 0) {
            this.pendingActionCount = 0;
            this.actionTakenCount = 0;
            this.processResCount = 0;
            this.totalResCount = data.length;
            for (let c = 0; c < data.length; c++) {
                if (data[c]['reqStatus'] == 3 || data[c]['reqStatus'] == 4) this.actionTakenCount++;
                else if (data[c]['reqStatus'] <= 3) this.pendingActionCount++;
                if (data[c]['reqStatus'] == 3 || data[c]['reqStatus'] == 4) { this.processResCount++; }
            }
        } else {
            this.pendingActionCount = 0;
            this.actionTakenCount = 0;
            this.processResCount = 0;
            this.totalResCount = 0;
        }
    }

    checkDriverImgShow() {
        if (this.viewRequestData && this.viewRequestData.whomToShow && this.viewRequestData.whomToShow.includes('Driver')) return true;
        else return false;
    }
    getUserCount(userKey) {
        if (this.requestResData && this.requestResData.length > 0) {
            let count = 0;
            for (let c = 0; c < this.requestResData.length; c++) {
                let data = this.requestResData[c];
                if (data[userKey]) count++;
            }
            return count;
        } else return 0;
    }
    checkEmpImgShow() {
        if (this.viewRequestData && this.viewRequestData.whomToShow && this.viewRequestData.whomToShow.includes('Employee')) return true;
        else return false;
    }

    changeTableView(type) {
        this.enableTable = false;
        this.noDataFoundEnable = false;
        this.activeTable = type;
        this.tableData = [];
        this.tableSearchKeys = [];
        if (this.requestResData && this.requestResData.length > 0) {
            for (let c = 0; c < this.requestResData.length; c++) {
                let obj = { ...this.requestResData[c] };
                if (type == 'actionTaken' && this.requestResData[c]['actionMessage'] && this.requestResData[c]['reqStatus'] && this.requestResData[c]['reqStatus'] >= 3) {
                    this.tableData.push(obj);
                    this.tableSearchKeys = Object.keys(obj);
                    this.checked = false;
                    this.resetingTableValues();
                }
                else if (type == 'pendingAction' && (this.requestResData[c]['actionMessage'] == undefined || this.requestResData[c]['reqStatus'] < 3)) {
                    this.tableData.push(obj);
                    this.tableSearchKeys = Object.keys(obj);
                    this.resetingTableValues();
                }
            }
        }
        //console.log("this>>>>>>>>",this.tableData)
        if (['adhoc_request','route_cancel','route_request'].includes(this.viewRequestData['requestType'])) {
            for (let i = 0; i < this.tableData.length; i++) {
                // if (this.tableData[i]?.reqType == 'route_request') {
                //     if (this.tableData[i]['pickup']) {
                //         this.tableData[i]['transitMode'] = ['Login'];
                //     }
                //     if (this.tableData[i]['drop']) {
                //         this.tableData[i]['transitMode'] = ['Logout'];
                //     }
                // } else {
                    if (this.tableData[i]['pickup']) {
                        this.tableData[i]['transitMode'] = ['Pickup'];
                    }
                    if (this.tableData[i]['drop']) {
                        this.tableData[i]['transitMode'] = ['Drop'];
                    }
                // }
            }
        }
        if (this.isRouteLocationChangeRequest()) {
            for (let i = 0; i < this.tableData.length; i++) {
                const branchValue = this.tableData[i]['branchName'] || this.tableData[i]['branch'];
                this.tableData[i]['branch'] = this.getBranchName(branchValue);
                if (!this.tableData[i]['nodal']) {
                    this.tableData[i]['nodal'] = this.tableData[i]['nodalPoint'] || this.tableData[i]['nodalPoints'];
                }
            }
        }
        if (type == 'actionTaken') this.tableData = this.tableData.sort((a: any, b: any) => b['updatedAt'] - a['updatedAt']);

        this.enableTable = true;
        this.noDataFoundEnable = true;
    }


    convertTitleCase(title: string) {
        let titleArray = title.toLowerCase().split(' ');
        for (var i = 0; i < titleArray.length; i++) {
            titleArray[i] = titleArray[i].charAt(0).toUpperCase() + titleArray[i].slice(1);
        }
        return titleArray.join(' ');
    }

    firstLetterCapitalize(str: string) {
        return str[0].toUpperCase() + str.slice(1).toLowerCase();
    }

    getBranchName(id: any) {
        if (!id) return '';
        return this.branchInformation[id] || id;
    }

    getVisibleTableColumns(includeStatus: boolean = false) {
        return (this.tableCols || []).filter((col: any) => {
            if (!col?.checked) return false;
            const isStatusCol = !!(col.config && col.config.reqStatus);
            return includeStatus ? isStatusCol : !isStatusCol;
        });
    }

    hasStatusColumn() {
        return this.isRouteLocationChangeRequest() || this.getVisibleTableColumns(true).length > 0;
    }

    getColumnValue(res: any, col: any) {
        if (!col) return '---';

        const rawValue = res?.[col.key];
        const normalizedValue = this.normalizeDisplayValue(rawValue);

        if (col.config?.isLowerCase) {
            return normalizedValue;
        }

        if (col.config?.isUpperCase) {
            return normalizedValue.toUpperCase();
        }

        if (col.config?.isBoolean) {
            return this.normalizeDisplayValue(this.showBooleanValue(res, col));
        }

        if (col.config?.isShift) {
            return this.convertTitleCase(this.normalizeDisplayValue(res?.pickup || res?.drop));
        }

        if (col.config?.isDate) {
            return this.formatColumnDate(rawValue, col.config.format);
        }

        if (col.config?.isMap) {
            const mapValue = res?.[col.key];
            if (mapValue && typeof mapValue === 'object') {
                if (mapValue.name) return this.convertTitleCase(this.normalizeDisplayValue(mapValue.name));
                if (mapValue.lat !== undefined && mapValue.lng !== undefined) {
                    return `${mapValue.lat}, ${mapValue.lng}`;
                }
            }
            return '---';
        }

        if (this.shouldTitleCaseColumn(col.key)) {
            return this.convertTitleCase(normalizedValue);
        }

        return normalizedValue;
    }

    getColumnTooltip(res: any, col: any) {
        const value = this.getColumnValue(res, col);
        return value !== '---' ? value : '';
    }

    shouldTruncateColumn(col: any) {
        return !(col?.config?.reqStatus);
    }

    getStatusIcon(status: any) {
        const parsedStatus = +status;
        if (parsedStatus === 2) return 'autorenew';
        if (parsedStatus === 3) return 'check_circle';
        if (parsedStatus === 4) return 'cancel';
        return 'pending';
    }

    getStatusTooltip(status: any) {
        const parsedStatus = +status;
        if (parsedStatus === 2) return 'In-progress';
        if (parsedStatus === 3) return 'Completed';
        if (parsedStatus === 4) return 'Rejected';
        return 'Pending';
    }

    getStatusStyle(status: any) {
        const parsedStatus = +status;
        if (parsedStatus === 2) return { color: 'rgb(145, 61, 201)' };
        if (parsedStatus === 3) return { color: 'green' };
        if (parsedStatus === 4) return { color: 'grey' };
        return { color: 'orange', fontSize: '20px', lineHeight: '20px' };
    }

    isRouteLocationChangeRequest() {
        return this.viewRequestData?.requestType === 'route_location_change_request';
    }

    private formatColumnDate(value: any, displayFormat: string) {
        if (value === null || value === undefined || value === '') return '---';

        try {
            return formatDate(value, displayFormat, 'en-US');
        } catch (error) {
            return '---';
        }
    }

    private normalizeDisplayValue(value: any): string {
        if (value === null || value === undefined || value === '') return '---';

        if (Array.isArray(value)) {
            const mappedValues = value
                .map((item: any) => this.normalizeDisplayValue(item))
                .filter((item: string) => item !== '---');
            return mappedValues.length ? mappedValues.join(', ') : '---';
        }

        if (typeof value === 'object') {
            if (value.name) return String(value.name);
            if (value.label) return String(value.label);
            if (value.branchName) return String(value.branchName);
            if (value.nodalName) return String(value.nodalName);
            if (value.lat !== undefined && value.lng !== undefined) return `${value.lat}, ${value.lng}`;

            const mappedValues = Object.values(value)
                .filter((item: any) => item !== null && item !== undefined && item !== '')
                .map((item: any) => String(item));
            return mappedValues.length ? mappedValues.join(', ') : '---';
        }

        return String(value);
    }

    private shouldTitleCaseColumn(key: string): boolean {
        if (!key) return false;
        const titleCaseKeys = [
            'area',
            'city',
            'zone',
            'zoneName',
            'zone_name',
            'nodal',
            'nodalPoint',
            'nodalPoints',
            'message',
            'note',
            'title',
            'address',
            'location',
            'locationName',
            'branch',
            'street',
            'locality'
        ];
        return titleCaseKeys.includes(key);
    }

    setTableCols(formFields) {
        if (this.tableData['location']) {
            this.tableCols = [
                { key: 'lat', display: 'Lat' },
                { key: 'lng', display: 'Lng' },
            ];
        }
        //console.log("this.viewRequestData['requestType']>>>", this.viewRequestData['requestType'])
        if (this.isRouteLocationChangeRequest()) {
            this.tableCols = [
                { key: 'empName', display: 'Name', checked: true, headerConfig: { isDefault: true } },
                { key: 'empRefID', display: 'Employee ID', checked: true, config: { isUpperCase: true }, headerConfig: { isDefault: true } },
                { key: 'date', display: 'Date', checked: true, config: { isDate: true, format: 'dd MMM YYYY' }, headerConfig: { isDefault: true } },
                {
                    key: 'location', display: 'Location', checked: true, config: {
                        isMap: true,
                        truncateData: {
                            limit: 40,
                            concatVal: '...',
                        }
                    }
                },
                { key: 'area', display: 'Area', checked: true },
                { key: 'branch', display: 'Branch', checked: true },
                { key: 'nodal', display: 'Nodal Point', checked: true },
                { key: 'transitMode', display: 'Transit mode', checked: true },
                {
                    key: 'message', display: 'Message', checked: true, config: {
                        isMessage: true,
                        truncateData: {
                            limit: 30,
                            concatVal: '...',
                        }
                    }
                },
                { key: 'createdAt', display: 'Submission date', checked: true, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, headerConfig: { isDefault: true } },
            ];
        }
        else if (['route_request', 'route_change', 'route_cancel', 'adhoc_request'].includes(this.viewRequestData['requestType'])) {
            this.tableCols = [
                { key: 'empName', display: 'Name', checked: true },
                { key: 'empRefID', display: 'Employee ID', checked: true, config: { isUpperCase: true }, headerConfig: { isDefault: true } },
                { key: 'createdAt', display: 'Submission date', checked: true, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, headerConfig: { isDefault: true } },
                { key: 'date', display: 'Trip date', checked: true, config: { isDate: true, format: 'dd MMM YYYY' }, headerConfig: { isDefault: true } },
                { key: 'reqStatus', display: 'Status', checked: true, config: { reqStatus: true } },
            ];
        }
        else {
            this.tableCols = [
                { key: 'empName', display: 'Name', checked: true, headerConfig: { isDefault: true } },
                { key: 'empRefID', display: 'Employee ID', checked: true, config: { isUpperCase: true }, headerConfig: { isDefault: true } },
                { key: 'createdAt', display: 'Submission date', checked: true, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, headerConfig: { isDefault: true } },
                { key: 'reqStatus', display: 'Status', checked: true, config: { reqStatus: true } },
            ];
        }
        if (formFields && formFields.length > 0 && !this.isRouteLocationChangeRequest()) {
            for (let f = 0; f < formFields.length; f++) {
                let field = formFields[f];
                if (field.label) {
                    let obj = { key: field.name, display: this.firstLetterCapitalize(field.label) }
                    obj['checked'] = this.columnObj[field.name] ? true : false;
                    if (field.type == 'date' || field.type == 'multipleDate') obj['config'] = { isDate: true, format: 'dd MMM YYY' };
                    else if (field.type == 'map') {
                        obj['config'] = {
                            isMap: true,
                            truncateData: {
                                limit: 40,
                                concatVal: '...',
                            }
                        }
                    }
                    else if (field.type == 'text') {
                        obj['config'] = {
                            isMessage: true,
                            truncateData: {
                                limit: 30,
                                concatVal: '...',
                            }
                        }
                    } else if (field.type == 'dynamicDropdown') {
                        obj['config'] = { isShift: true }
                    }
                    let colIndex = this.tableCols.findIndex((col) => col.key == field.name);
                    if (colIndex == -1) this.tableCols.push(obj);
                    if (!Object.keys(this.columnObj).includes(obj['key']))
                        this.columnObj[obj['key']] = obj['checked']
                }
            }
        }
        setTimeout(() => { this.changeTableView(this.activeTable); }, 100);
    }

    processFormPreview(fields) {
        this.requestFormFields = [];
        if (fields && fields.length > 0) {
            for (let d = 0; d < fields.length; d++) {
                let field = { ...fields[d] };
                this.requestFormFields.push({ ...field });
            }
        }
    }

    isNumber(o): boolean {
        return !isNaN(o - 0) && o !== null && o !== '' && o !== false;
    }
    showBooleanValue(elt, column) {
        return column.config.values[`${elt[column.key]}`];
    }
    openTakeAction(res) {
        this.editTakeActionData = {};
        this.reqModalTitle = 'Take Action';
        this.editTakeActionData = {
            requestID: this.requestID,
            data: this.checkedDatas,
            ...res,
        };
        this.closeActionTaken = false;
    }

    openFormPreview(showValue: any, res: any) {
        let tempArray = [];
        this.closeFormPreview = true;
        this.currentPreviewResponseData = res ? { ...res } : {};

        this.requestFormTitle = this.viewRequestData.title ? this.viewRequestData.title : '';
        this.requestFormNote = this.viewRequestData.note ? this.viewRequestData.note : '';
        if (this.requestFormFields && this.requestFormFields.length > 0) {

            for (let d = 0; d < this.requestFormFields.length; d++) {

                let name = this.requestFormFields[d]['name'];
                if (res && res[name] != undefined) {
                    if (this.requestFormFields[d]['type'] == 'date') {
                        let dateStr = new Date(res[name]).getDate() + '/' + new Date(res[name]).getMonth() + '/' + new Date(res[name]).getFullYear();
                        this.requestFormFields[d]['value'] = dateStr;
                    }
                    else this.requestFormFields[d]['value'] = res[name];
                }
                else {
                    this.requestFormFields[d]['value'] = '';
                }
                let temp = this.requestFormFields[d];
                tempArray[d] = temp;
            }
            this.FormPreviewData = tempArray;
        }
        setTimeout(() => {
            this.closeFormPreview = false;
        }, 100)
    }

    onActionHandler(e) {
        console.log(e);
    }

    openRequestResponseView(res: any) {
        if (res?.appRequestID) {
            this.router.navigate([
                '/organization/transport-manager/request/response-view',
                this.paramReqType,
                this.requestID,
                res.appRequestID
            ]);
        }
    }

    takeActionResult(obj) {
        this.api.RequestResUpdate(obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status, res.status, res.message, 2000);
            } else {
                this.swal.swalFunction('error', 'failure', res.message, 2000);
            }
            this.getRequestResponses(this.filterObj);
            this.approveBtn = false;
            this.checked = false;
            this.checkedDatas = [];

        }).catch((err) => {
            console.log(err);
        });
    }

    getStrStatus(status: any) {
        status = +status;
        if (status == 2) {
            return "In-progress";
        } else if (status == 3) {
            return "Completed";
        } else if (status == 4) {
            return "Rejected";
        } else {
            return "Pending";
        }
    }
    public actionCols: any = [];


    async rosterExcel() {
        this.excelData2 = {};
        
        let data = [];
        let serialNo = 1;
        for (let i = 0; i < this.reqExlData.length; i++) {
            let item = this.reqExlData[i];
           // console.log("itemsssss",item)
            try {
                let res = {
                    value: [
                        // serialNo++,
                        item.empRefID ? item.empRefID : '---',
                        item.transitMode == 'Login'? 'pickup': item?.transitMode == 'Logout' ? 'drop' : '',
                        (item?.transitMode  && item?.pickup) ? item.pickup : item?.transitMode == 'Logout' ? item?.drop : '---',
                        item?.mobile ? item?.mobile : ' ',
                        item?.supervisorMail ? item?.supervisorMail : '',
                        item?.project ? item?.project : '',
                    ],

                    border: {
                        right: { style: 'thin' }, bottom: { style: 'thin' },
                    },
                    alignment: {
                        vertical: 'middle', // Center vertically
                        horizontal: 'center', // Center horizontally
                    },
                };
                data.push(res);


            } catch (err) {
                console.log(err);
            }
        }
        if (data.length > 0) {
            let rowCount = 2;
            let endCell = 'F';
            let customizedData = [];
            let headerRow =
            {
                value: [ "Employee Id**", "TripType**","Shift Time", "Mobile", "Supervisor Email Id", "Project"],
                font: { bold: true },
                border: {
                    top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
                    height: 30, // Increase header row height
                },
                height: 40,
                alignment: [
                    { cell: 'A1', value: { vertical: 'middle', horizontal: 'center' } },
                    { cell: 'B1', value: { vertical: 'middle', horizontal: 'center' } },
                    { cell: 'C1', value: { vertical: 'middle', horizontal: 'center' } },
                    { cell: 'E1', value: { vertical: 'middle', horizontal: 'center' } },
                    { cell: 'D1', value: { vertical: 'middle', horizontal: 'center' } },
                    { cell: 'F1', value: { vertical: 'middle', horizontal: 'center' } },
                    // { cell: 'G1', value: { vertical: 'middle', horizontal: 'center' } },
                ],
            }
            customizedData.push(headerRow);

            customizedData.push(...data);
            let excelSheetName = 'Sheet1'

            if (this.excelData2[excelSheetName] == undefined) { this.excelData2[excelSheetName] = {}; }

            this.excelData2[excelSheetName] = {
                customizedData: customizedData,
                data: {
                    columWith: [{ colNo: 1, width: 18 },{ colNo: 2, width: 20 }, { colNo: 3, width: 18 }, { colNo: 4, width: 18 }, { colNo: 5, width: 30 }, { colNo: 6, width: 30 }, { colNo: 7, width: 30 },{ colNo: 8, width: 30 },],
                }
            }

            // this.downloadRosterTemplateExl();
        }
    }

    // Excel Upload
    async exportToExcel() {
        let data = [];
        const startDate = new Date(this.shiftChangeForm.value.startDate + '');
        const endDate = new Date(new Date(this.shiftChangeForm.value.endDate + '').setHours(23, 59, 59));

        var cols = this.tableCols.filter((item: any) => item['checked'])
        if (this.activeTable == 'actionTaken') {
            this.actionCols = [
                { key: 'updatedAt', display: 'Action time', checked: true, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, headerConfig: { isDefault: true } },
                { key: 'actionMessage', display: 'Action message', checked: true, headerConfig: { isDefault: true } },
            ]
        }
        cols = [
            ...cols,
            ...this.actionCols
        ];

        let headerRowsValues = []

        for (let i = 0; i < this.reqExlData.length; i++) {
            let item = this.reqExlData[i];
            if (item['actionMessage'] && item['reqStatus'] && item['reqStatus'] >= 3) {
                try {
                    let value: any = [
                        i + 1,
                        // item.name?item.name:'---',
                        // item.createdAt ? this.com.timestampToDate(new Date(item.createdAt).getTime(), 'DMY') : '--/--/----',
                        // this.getStrStatus(item.reqStatus)
                    ];
                    headerRowsValues = ['S No']

                    for (let j = 0; j < cols.length; j++) {
                        let colItem = cols[j];
                        headerRowsValues.push(colItem['display'] ? colItem['display'] : '---')
                        let colValue = '';
                        if (colItem.config && colItem.config.isDate) {
                            let dateFormat = 'DMY';
                            if (colItem.config.format == 'dd MMM YYYY, hh:mm a') dateFormat = 'DMY H:M A'
                            colValue = item[colItem.key] ? this.com.timestampToDate(new Date(item[colItem.key]).getTime(), dateFormat, '/') : '--/--/----';
                        } else {
                            colValue = item[colItem.key] ? String(item[colItem.key]).trim() : '---';
                        }
                        if (colItem.key == 'reqStatus') {
                            colValue = this.getStrStatus(item[colItem.key]);
                        }
                        if (colItem.config && colItem.config.isMap) {
                            colValue = item[colItem.key]['name']
                        }
                        if (colItem.config && colItem.config.isShift) {
                            if (item.pickup) {
                                colValue = item.pickup;
                            } else if (item.drop) {
                                colValue = item.drop;
                            } else {
                                colValue = '---';
                            }
                        }
                        if ((['route_request','route_cancel','adhoc_request'].includes(item.reqType)) && colItem.key == 'transitMode') {
                            if (item.pickup) {
                                colValue = 'Pickup';
                            } else if (item.drop) {
                                colValue = 'Drop';
                            } else {
                                colValue = '---';
                            }
                        }

                        value.push(colValue);
                    }
                    let res = {
                        value: value
                    };
                    data.push(res); //data.length => 21
                } catch (err) {
                    console.log(err);
                }
            }
        }

        if (data.length > 0) {
            let customizedData = [];
            let endColumn = this.letters[cols.length]
            let titleRow = {
                value: [this.viewRequestData['title'] ? this.com.convertTitleCase(this.viewRequestData['title']) : "App Request"],
                mergeCells: [`A1:${endColumn}2`],
                font: {
                    name: 'Corbel', family: 4, size: 16, bold: true,
                    color: { argb: 'FFFFFFFF' },
                },
                alignment: {
                    cell: "A1", value: { vertical: 'middle', horizontal: 'center' },
                },
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '966462AF' },
                    bgColor: { argb: '966462AF' }
                },
            }
            customizedData.push(titleRow);
            let subtitleRow = {
                value: ["Start Date  : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                    "End Date    : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY')],
                font: { name: 'Corbel', family: 4, size: 12, },
                mergeCells: [`A3:${endColumn}4`],
            }
            customizedData.push(subtitleRow);
            let headerRow =
            {
                value: headerRowsValues,
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFFF00' },
                    bgColor: { argb: 'FF0000FF' }
                },
                font: { bold: true },
                border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);

            customizedData = [...customizedData, ...data];

            const excelInfo = {
                customizedData: customizedData,
                data: {
                    columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 25 }, { colNo: 4, width: 20 }, { colNo: 5, width: 30 }, { colNo: 6, width: 30 }, { colNo: 7, width: 30 }, { colNo: 8, width: 30 }, { colNo: 9, width: 30 }, { colNo: 10, width: 35 }, { colNo: 11, width: 20 }, { colNo: 12, width: 20 }]
                }
            };
            if (this.excelData['App_Request_Excel'] == undefined) { this.excelData['App_Request_Excel'] = {}; }

            this.excelData['App_Request_Excel'] = excelInfo;

            //   this.exlNoDataFound = false;
            this.showDownloadBtn = true;
        }
        // else this.exlNoDataFound = true;
        // this.downloadExlReport();
    }

    downloadExlReport() {
        this.excel.generateExcel(this.excelData, 'App_Request_Excel.xlsx');
    }

    downloadRosterTemplateExl() {
        this.excel.generateExcel(this.excelData2, 'Roster template - Auto_Roster.xlsx');
    }

    public letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

}


// {
//     name:'Mathan M',
//     employeeID:'611226d307434a2d0f3a0bd0',
//     currentLocation:'Chennai',
//     latlng:'kancheepuram',
//     date:1646934012530,
//     message:'Need to change location',
//     requestID: "621dfefaa1c3ea1c9c6d933a"
// }




